
import React, { useState, useEffect, useRef } from "react";
import ProductModal from "./ProductModal";  // 모달 컴포넌트 추가
import AuthModal from "./AuthModal";  // 로그인 및 회원가입 모달 추가
import IntroductionSection from "./IntroductionSection"; // ✅ 추가
import {getNewAccessToken} from "./SignInRefreshToken"; // ✅ 추가
import FeedBackSection from "./FeedBackSection";







const KeywordSearchApp = () => {

    const API_URL = process.env.REACT_APP_API_URL;
    const [query, setQuery] = useState("");
    const [results, setResults] = useState([]);
    const [showTable, setShowTable] = useState(false);
    const [showInitialMessage, setShowInitialMessage] = useState(true);
    const [modalOpen, setModalOpen] = useState(false);
    const [selectedProducts, setSelectedProducts] = useState([]);
    const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });

    const [authModalOpen, setAuthModalOpen] = useState(false); // 로그인/회원가입 모달 상태

    const handleAuthModalOpen = () => setAuthModalOpen(true);
    const handleAuthModalClose = () => setAuthModalOpen(false);

    const [isAuthenticated, setIsAuthenticated] = useState(
      localStorage.getItem("isAuthenticated") === "true"
      );
    const [isMenuOpen, setIsMenuOpen] = useState(false);  // ✅ 모바일 메뉴 상태 추가
    const [isSubMenuOpen, setIsSubMenuOpen] = useState(false);
    const menuRef = useRef(null);  // ✅ 메뉴 영역을 감지하기 위한 ref 생성


    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
    };
    const toggleSubMenu = () => {
        setIsSubMenuOpen(!isSubMenuOpen);
    };

    const [placeholder, setPlaceholder] = useState("로그인 후 검색하세요");
     // ✅ 처음 렌더링할 때 로그인 상태 확인

     useEffect(() => {
        const checkAuthentication = async () => {

            const accessToken = sessionStorage.getItem("accessToken");

            if (accessToken) {
                console.log("✅ 기존 Access Token 존재! 로그인 유지");
                setIsAuthenticated(true);
                localStorage.setItem("isAuthenticated", "true"); // 상태 저장
                return;

            }


             // ✅ 로그아웃 상태에서는 Refresh Token 요청 X
            if (localStorage.getItem("isAuthenticated") !== "true") {
                console.log("⛔ 로그아웃 상태이므로 Refresh Token 요청 중단");
                return;
            }

            console.log("🔄 Access Token 없음. Refresh Token으로 갱신 시도...");
            const newAccessToken = await getNewAccessToken();


            if (newAccessToken) {
                console.log("✅ Refresh Token으로 로그인 성공!");
                setIsAuthenticated(true);
                sessionStorage.setItem("accessToken", newAccessToken); // ✅ 새 Access Token 저장

                localStorage.setItem("isAuthenticated", "true"); // 상태 저장

            } else {
                console.log("⛔ 자동 로그인 실패. 로그인 필요");
                setIsAuthenticated(false);
                sessionStorage.removeItem("accessToken"); // ✅ 로그아웃 시 Access Token 삭제

                localStorage.removeItem("isAuthenticated"); // 로그아웃 처리
                }
            };

        checkAuthentication();
      }, []); 



       // ✅ 검색창 플레이스홀더 상태 업데이트
    useEffect(() => {
        setPlaceholder(isAuthenticated ? "검색어를 입력하세요" : "로그인 후 검색하세요");
    }, [isAuthenticated]);


     // ✅ "외부 클릭 감지"를 위한 `useEffect`
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (menuRef.current && !menuRef.current.contains(event.target)) {
                setIsMenuOpen(false);  // 외부 클릭 시 메뉴 닫기
                setIsSubMenuOpen(false); // 하위 메뉴도 닫기
            }
        };

        document.addEventListener("mousedown", handleClickOutside);  // 클릭 감지 이벤트 추가
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);  // 컴포넌트 언마운트 시 이벤트 제거
        };
    }, []);





    // 로그인 성공 시 실행될 함수
    const handleLoginSuccess = () => {
        console.log("🔥 handleLoginSuccess 실행됨! isAuthenticated 값을 true로 변경"); // 디버깅 로그 추가

        setIsAuthenticated(true);  // 로그인 후 검색창 활성화
        localStorage.setItem("isAuthenticated", "true"); // ✅ 로그인 성공 후 localStorage에 저장

        setAuthModalOpen(false);   // 로그인 후 모달 닫기
    };



    // ✅ 로그아웃 함수 추가
    const handleLogout = async () => {
        console.log("🚀 로그아웃 실행됨! isAuthenticated를 false로 변경");

        try {
            // ✅ FastAPI 서버에 Refresh Token 삭제 요청
            await fetch(`${API_URL}/logout`, {
                method: "POST",
                credentials: "include", // ✅ Refresh Token 삭제를 위해 쿠키 포함
            });

            sessionStorage.removeItem("accessToken"); // ✅ Access Token 삭제
            localStorage.removeItem("isAuthenticated"); // 로그아웃 처리
            setIsAuthenticated(false);  // ✅ 상태 변경
            alert("로그아웃 되었습니다!");
            
            window.location.reload(); // ✅ 모든 탭에서 변경 사항 반영
        } catch (error) {
            console.error("⛔ 로그아웃 실패:", error);
        }
    };

    // ✅ 다른 탭에서 로그아웃 감지
    useEffect(() => {
        const handleStorageChange = (event) => {
            if (event.key === "isAuthenticated" && event.newValue === null) {
                console.log("🚀 다른 탭에서 로그아웃 감지됨!");
                setIsAuthenticated(false);
                sessionStorage.removeItem("accessToken"); // ✅ 다른 탭에서 로그아웃하면 Access Token 삭제

            }
        };

        window.addEventListener("storage", handleStorageChange);
        return () => {
            window.removeEventListener("storage", handleStorageChange);
        };
    }, []);


    const handleSearch = async () => {
        if (!query) {
            alert("검색어를 입력하세요!");
            return;
        }

        setShowInitialMessage(false);
        setShowTable(false);

        const accessToken = sessionStorage.getItem("accessToken"); // ✅ 저장된 Access Token 가져오기
        // console.log("🛠️ 현재 Access Token:", accessToken);




        try {
            const response = await fetch(`${API_URL}/search?q=${encodeURIComponent(query)}`, {
                method: "GET",
                headers: {
                    "Authorization": `Bearer ${accessToken}`,  // ✅ 토큰 추가
                    "Content-Type": "application/json"
                }
            });

            if (response.status === 401) {  // ✅ 토큰이 만료된 경우
                console.log("🔄 Access Token이 만료됨. Refresh Token으로 새로고침 시도...");
                const newAccessToken = await getNewAccessToken();

                if (newAccessToken) {
                    accessToken = newAccessToken;
                    sessionStorage.setItem("accessToken", newAccessToken); // ✅ 새로운 토큰 저장

                    // ✅ 새로운 Access Token으로 다시 요청
                    response = await fetch(`${API_URL}/search?q=${encodeURIComponent(query)}`, {
                        method: "GET",
                        headers: {
                            "Authorization": `Bearer ${accessToken}`,
                            "Content-Type": "application/json"
                        }
                    });
                } else {
                    alert("로그인 세션이 만료되었습니다. 다시 로그인해주세요.");
                    return;
                }
            }


            const data = await response.json();

            if (response.ok) {
                setResults(data.results || []);
                setShowTable(true);
            } else {
                setResults([]);
                setShowTable(true);
            }
        } catch (error) {
            console.error("검색 오류:", error);
            setResults([]);
            setShowTable(true);
        }
    };

    const handleSort = (key) => {
        let direction = "asc";
        if (sortConfig.key === key && sortConfig.direction === "asc") {
            direction = "desc";
        }

        // console.log(key)
        // console.log(results)

        const sortedResults = [...results].sort((a, b) => {
            const valueA = parseFloat(a[key]);
            const valueB = parseFloat(b[key]);

            if (valueA < valueB) return direction === "asc" ? -1 : 1;
            if (valueA > valueB) return direction === "asc" ? 1 : -1;
            return 0;
        });

        setResults(sortedResults);
        setSortConfig({ key, direction });
    };

    const handleKeyPress = (event) => {
        if (event.key === "Enter") {
            if (!isAuthenticated) {
                alert("로그인 후 검색이 가능합니다!");
                return;
            }
            console.log("🚀 Enter 키 눌림, 검색 실행됨!");
            handleSearch(); // ✅ Enter 키를 누르면 검색 실행
        }
    };

    const handleProductClick = (productNames) => {
        if (productNames) {
            const productList = JSON.parse(productNames); 
            console.log(typeof productList)
            setSelectedProducts(productList);
            setModalOpen(true);
        }
    };
    

    return (
        <div className="min-h-screen bg-black text-white">
        {/* <div className="w-full bg-black text-white"> */}

            {/* 네비게이션 바 */}
            <nav className="bg-black text-white fixed top-0 w-full z-10 border-b border-gray-700">

                <div className="container mx-auto flex justify-between items-center py-3 px-4 m-0">
                  {/* ✅ 로고 이미지 추가 */}
                    <a href="/">
                        <img src="/madworks_logo.png" alt="매드웍스 키워드 검색기" className="h-12" />
                    </a>

                    {/* <ul className="flex space-x-10"> */}
                    <ul className="hidden md:flex gap-20">
                        <li><a href="/" className="hover:text-blue-500">홈</a></li>
                        <li><a href="/about" className="hover:text-blue-500">소개</a></li>
                        {/* <li className="relative group px-4 py-2 hover:bg-gray-700"> */}
                        <li className="relative group px-4 py-0 hover:bg-gray-700">
                            <span className="hover:text-blue-500 cursor-pointer">서비스</span>
                            <ul className="absolute left-0 mt-0 hidden group-hover:block bg-gray-800 text-white w-40 shadow-lg z-50">
                                <li className="px-4 py-2 hover:bg-gray-700 hover:text-blue-500">
                                    <a href="https://kmong.com/gig/491247" target="_blank">상품대장편집기</a>
                                </li>
                                <li className="px-4 py-2 hover:bg-gray-700 hover:text-blue-500">
                                    <a href="https://kmong.com/gig/535146" target="_blank">매드워드</a>
                                </li>
                                <li className="px-4 py-2 hover:bg-gray-700 hover:text-blue-500">
                                    <a href="https://kmong.com/gig/524586" target="_blank">매드썸네일</a>
                                </li>
                                <li className="px-4 py-2 hover:bg-gray-700 hover:text-blue-500">
                                    <a href="https://kmong.com/gig/560698" target="_blank">매드스마트</a>
                                </li>
                                <li className="px-4 py-2 hover:bg-gray-700 hover:text-blue-500">
                                    <a href="https://kmong.com/gig/500772" target="_blank">프로그램 제작 의뢰</a>
                                </li>
                            </ul>
                        </li>
                        <li><a href="/contact" className="hover:text-blue-500">문의</a></li>
                    </ul>
                    
                    {/* 로그인 / 로그아웃 버튼 */}
                    <div className="flex items-center ml-auto md:ml-0">
                      {isAuthenticated ? (
                        <button 
                          onClick={handleLogout} 
                          className="bg-red-400 px-3 py-1 rounded-md hover:bg-red-500"
                        >
                          로그아웃
                        </button>
                      ) : (
                        <button 
                          onClick={handleAuthModalOpen} 
                          className="bg-blue-400 px-3 py-1 rounded-md hover:bg-blue-500 ml-auto md:ml-0"
                        >
                          로그인
                        </button>
                      )}
                    </div>

                


                    {/* <!-- 모바일 메뉴 버튼 (햄버거 메뉴) --> */}
                    <div className="md:hidden flex items-center">
                        <button onClick={toggleMenu} id="menu-toggle" className="text-white focus:outline-none">
                            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16"></path>
                            </svg>
                        </button>
                    </div>

                </div>

                {/* <!-- 모바일 네비게이션 링크 --> */}
                <ul ref={menuRef} className={`absolute top-full left-0 w-full bg-gray-900 text-white space-y-4 p-4 transition-all duration-300 ${isMenuOpen ? "block" : "hidden"}`}>
                    <li><a href="/" className="block hover:text-blue-500">홈</a></li>
                    <li><a href="https://www.mad-pipe.com/40%EB%8C%80-%EA%B2%BD%EC%A0%9C%EC%A0%81-%EC%9E%90%EC%9C%A0-%EC%8B%A4%EC%B2%9C%EA%B8%B0/" className="block hover:text-blue-500">소개</a></li>
                    {/* <li><a href="/services" className="block hover:text-blue-500">서비스</a></li> */}
                    <li className="relative">
                        <button 
                            onClick={toggleSubMenu} 
                            className="flex justify-between items-center w-full text-left hover:text-blue-500"
                        >
                            서비스
                            <span>{isSubMenuOpen ? "▲" : "▼"}</span>  {/* 펼침/닫힘 아이콘 */}
                        </button>

                        {/* 하위 메뉴 */}
                        <ul className={`pl-4 space-y-2 transition-all duration-300 ${isSubMenuOpen ? "block" : "hidden"}`}>
                            <li><a href="https://kmong.com/gig/491247" className="block hover:text-blue-500">상품대장편집기</a></li>
                            <li><a href="https://kmong.com/gig/535146" className="block hover:text-blue-500">매드워드</a></li>
                            <li><a href="https://kmong.com/gig/524586" className="block hover:text-blue-500">매드썸네일</a></li>
                            <li><a href="https://kmong.com/gig/560698" className="block hover:text-blue-500">매드스마트</a></li>
                            <li><a href="https://kmong.com/gig/500772" className="block hover:text-blue-500">프로그램 제작 의뢰</a></li>
                        </ul>
                    </li>
                    <li><a href="mailto:madworks@mad-pipe.com" className="block hover:text-blue-500">문의</a></li>
                </ul>
                

            </nav>
            {/* 로그인 및 회원가입 모달 */}
            <AuthModal isOpen={authModalOpen} onLoginSuccess={handleLoginSuccess} onClose={handleAuthModalClose} />

            

            {/* 검색창 */}
            <main className="container mx-auto p-4 pt-20 mt-16 text-center">
                <h1 className="text-3xl font-bold mb-10 leading-relaxed font-noto">
                  쇼핑몰 상품명의 핵심인 키워드<br />
                  키워드를 쉽고 빠르게 찾을 수 있는 매드키워드
                  </h1>

                <section className="search-section">
                  <div className="flex justify-center mb-4">
                      <input
                          type="text"
                          className="border p-2 text-black w-1/2"
                          placeholder={placeholder}
                          value={query}
                          onChange={(e) => setQuery(e.target.value)}
                          onKeyPress={handleKeyPress}
                          disabled={!isAuthenticated}  // 로그인 전에는 비활성화
                      />
                      <button 
                          onClick={handleSearch}
                          className="bg-blue-500 text-white px-4 py-2 ml-2"
                          disabled={!isAuthenticated} // 로그인 전에는 버튼도 비활성화
                      >검색</button>
                  </div>
                  {/* <h2 id="search-guide" className="text-xl text-center mb-4 search-guide">쇼핑몰 연관검색어 및 경쟁강도 검색</h2>  */}

                  

                  {showInitialMessage && (
                    <section className="introduct-madkeyword">
                      <h2 className="text-center text-transparent bg-clip-text bg-gradient-to-r mb-6 mt-6 text-xl from-green-300 to-blue-500">
                        검색어를 입력하고 검색 버튼을 눌러 연관 키워드를 검색하고 경쟁 강도를 확인하세요.<br />
                      </h2>
                      <div className="text-sm text-white">
                        {/* 지금 빠르게 검색어를 입력하시면  */}
                      </div>
                    </section>
                    
                  )}


                </section>

                {/* 검색 결과 테이블 */}

                {showTable && (

                  <section className="search-results">
                    
                    <h2 className="text-2xl font-semibold mb-3">검색 결과</h2>
                    <div className="text-right w-full mb-2 pr-40">
                    
                      <span className="text-sm text-gray-400">총 키워드 개수: {results.length}개</span>
                    </div>

                    <div className="table-container flex justify-center">
                        <table className="table-auto bg-gray-900 w-4/5">
                            <thead>
                                <tr className="bg-gray-700">

                                  <th className="border px-4 py-2">연관 키워드</th>
                                  <th 
                                    className="border px-4 py-2 cursor-pointer hover:text-blue-400"
                                    onClick={() => handleSort("경쟁강도")}
                                  >
                                    경쟁 강도 {sortConfig.key === "경쟁강도" ? (sortConfig.direction === "asc" ? "▲" : "▼") : ""}
                                  </th>
                                  <th 
                                      className="border px-4 py-2 cursor-pointer hover:text-blue-400"
                                      onClick={() => handleSort("한달검색수")}
                                  >
                                      한달검색수 {sortConfig.key === "한달검색수" ? (sortConfig.direction === "asc" ? "▲" : "▼") : ""}
                                  </th>
                                </tr>
                            </thead>
                            <tbody>
                                {results.length > 0 ? (
                                    results.map((item, index) => (
                                        <tr key={index} className="bg-gray-800 text-white">
                                            <td className="border px-4 py-2 cursor-pointer hover:text-blue-400"
                                            onClick={() => handleProductClick(item.상위상품정보)}
                                            >{item.연관키워드}</td>
                                            <td className="border px-4 py-2 cursor-pointer hover:text-blue-400"
                                            onClick={() => handleProductClick(item.상위상품정보)}
                                            >{item.경쟁강도}</td>
                                            <td className="border px-4 py-2 cursor-pointer hover:text-blue-400"
                                            onClick={() => handleProductClick(item.상위상품정보)}
                                            >{item.한달검색수}</td>
                                            {/* <td className="border px-4 py-2">{item.상위상품명}</td> */}
                                             {/* <td className="border px-4 py-2 text-blue-400 cursor-pointer hover:text-blue-600"
                                                onClick={() => handleProductClick(item.상위상품명)}
                                            >{item.상위상품명}</td> */}
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="2" className="border px-4 py-2 text-center text-red-500">
                                            검색 결과가 없습니다.
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                  </section>
                )}


            </main>

            {/* ✅ 사이트 소개 섹션 추가 */}
            <div className="w-full">
              <IntroductionSection isAuthenticated={isAuthenticated} onSignupClick={handleAuthModalOpen} />
            </div>
            
            {/* ✅ 피드백 섹션 추가 */}
            <div className="w-full">
              <FeedBackSection />
            </div>


            {/* 모달 컴포넌트 */}
            <ProductModal 
                isOpen={modalOpen} 
                products={selectedProducts}
                onClose={() => setModalOpen(false)} 
            />



            {/* 푸터 */}
            <footer className="bg-black text-white text-center py-4 border-t border-gray-700">
                <p>&copy; 2024 매드웍스. All rights reserved.</p>
                <ul className="flex justify-center space-x-4 mt-2">
                    <li><a href="/privacy" className="hover:text-blue-500">개인정보처리방침</a></li>
                    <li><a href="/terms" className="hover:text-blue-500">이용약관</a></li>
                    <li><a href="/contact" className="hover:text-blue-500">문의하기</a></li>
                </ul>
                <div className="flex justify-center space-x-4 mt-4">
                    <a href="https://www.facebook.com/sharer/sharer.php?u=https://yourwebsite.com" target="_blank" className="hover:text-blue-600">
                        <img src="https://img.icons8.com/color/48/000000/facebook.png" alt="Facebook" className="w-8 h-8" />
                    </a>
                    <a href="https://twitter.com/intent/tweet?url=https://yourwebsite.com&text=Check%20this%20out!" target="_blank" className="hover:text-blue-400">
                        {/* <img src="https://img.icons8.com/ios-filled/50/000000/x.png" alt="X" className="w-8 h-8" /> */}
                        <img src="https://img.icons8.com/ios-filled/50/ffffff/x.png" alt="X" className="w-8 h-8" />

                    </a>
                    <a href="https://www.linkedin.com/shareArticle?mini=true&url=https://yourwebsite.com" target="_blank" className="hover:text-blue-700">
                        <img src="https://img.icons8.com/color/48/000000/linkedin.png" alt="LinkedIn" className="w-8 h-8" />

                    </a>
                    
                    <a href="https://api.whatsapp.com/send?text=https://yourwebsite.com" target="_blank" className="hover:text-green-500">
                        <img src="https://img.icons8.com/color/48/000000/whatsapp.png" alt="WhatsApp" class="w-8 h-8" />
                    </a>
                    <a href="https://www.instagram.com/madworks_pipe/" target="_blank" className="hover:text-pink-500">
                        <img src="https://img.icons8.com/color/48/000000/instagram-new.png" alt="Instagram" className="w-8 h-8" />
                    </a>

                    <a href="https://cafe.naver.com/madpipe" 
                    target="_blank" 
                    class="hover:text-green-500" >
                        <img src="naver_cafe.png" alt="Naver Cafe" className="w-8 h-8"/>
                    </a>
                </div>
            </footer>
        </div>
    );
};

export default KeywordSearchApp;
